export const AUTH_ACTIONS = {
  SET_TOKEN: 'SET_TOKEN',
  SET_USER: 'SET_USER',
  LOGOUT: 'LOGOUT',
};
